<template>
	<div>
		<div class="modal fade" id="modal-live" tabindex="-1">
			<div class="modal-dialog modal-md" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">直播購物車 +1</h4>
						<a href="#" class="close" data-dismiss="modal" aria-label="Close">
							<i class="icon-modal-close"></i>
						</a>
					</div>
					<div class="modal-body">
						<div class="position-relative mb-4">
							<div style="padding-right: 225px">
								<input v-model="ig_id" type="text" class="form-control" placeholder="請輸入InstagramID" />
							</div>
							<a
								@click="postID('Instagram')"
								:class="{ disabled: lockbtn }"
								href="#"
								class="btn btn-outline-secondary position-absolute"
								style="right: 140px; top: 0"
								>綁訂</a
							>
							<a
								@click="getShoppingDatas('Instagram')"
								href="#"
								class="btn btn-outline-secondary position-absolute"
								style="right: 0; top: 0"
								>取得直播商品</a
							>
						</div>
						<div class="position-relative mb-4">
							<div style="padding-right: 225px">
								<input v-model="fb_id" type="text" class="form-control" placeholder="請輸入FacebookID" />
							</div>
							<a
								@click="postID('Facebook')"
								:class="{ disabled: lockbtn }"
								href="#"
								class="btn btn-outline-secondary position-absolute"
								style="right: 140px; top: 0"
								>綁訂</a
							>
							<a
								@click="getShoppingDatas('Facebook')"
								href="#"
								class="btn btn-outline-secondary position-absolute"
								style="right: 0; top: 0"
								>取得直播商品</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			:class="{ 'd-none': !isRunning }"
			style="
				position: fixed;
				z-index: 2999;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				color: white;
				background: rgba(0, 0, 0, 1);
				font-size: 24px;
				text-align: center;
				line-height: 100vh;
			"
		>
			<div style="display: inline-block; vertical-align: middle; line-height: 1">
				<h1>處理中, 請稍後</h1>
				<h3>(請勿關閉頁面)</h3>
			</div>
		</div>
	</div>
</template>

<script>
import AlertDialog from "@global/helpers/alertDialog";

export default {
	name: "streamCart",
	data() {
		return {
			ig_id: null,
			fb_id: null,
			selectedID: null,
			lockbtn: false,
			isRunning: false,
		};
	},
	mounted() {
		const _this = this;
		$("#modal-live").on("show.bs.modal", function (e) {
			_this.getInitID();
		});
	},
	methods: {
		getInitID: function () {
			const _this = this;
			$.ajax({
				url: "/api/v1/UrPlus/Account",
				type: "GET",
				dataType: "JSON",
				data: "Source=Instagram",
			})
				.done(function (res) {
					if (res.Code === 200) {
						_this.ig_id = res.Message;
					}
				})
				.fail(function () {
					console.log("error");
				});

			$.ajax({
				url: "/api/v1/UrPlus/Account",
				type: "GET",
				dataType: "JSON",
				data: "Source=Facebook",
			})
				.done(function (res) {
					if (res.Code === 200) {
						_this.fb_id = res.Message;
					}
				})
				.fail(function () {
					console.log("error");
				});
		},
		getCurrentID: function (s) {
			if (s === "Instagram") {
				this.selectedID = this.ig_id;
			} else if (s === "Facebook") {
				this.selectedID = this.fb_id;
			}
		},
		postID: function (s) {
			const _this = this;
			this.getCurrentID(s);
			if (this.selectedID === null) {
				AlertDialog.alert("請輸入社群ID");
				return;
			}
			_this.lockbtn = true;
			$.ajax({
				url: "/api/v1/UrPlus/Account",
				type: "POST",
				dataType: "JSON",
				data: { Name: this.selectedID, Source: s },
			})
				.done(function (res) {
					if (res.Code === 200) {
						AlertDialog.alert("帳號已綁定", function () {
							_this.lockbtn = false;
						});
					} else if (res.Code === 401) {
						AlertDialog.alert("請先登入");
					} else {
						_this.lockbtn = false;
						AlertDialog.alert("系統忙碌中");
					}
				})
				.fail(function () {
					console.log("error");
				});
		},
		getShoppingDatas: function (s) {
			const _this = this;
			this.getCurrentID(s);
			if (this.selectedID === null) {
				AlertDialog.alert("請輸入社群ID");
				return;
			}
			_this.isRunning = true;
			$.ajax({
				url: "/api/v1/UrPlus/LiveShoppingCart",
				type: "GET",
				dataType: "JSON",
				data: "Name=" + this.selectedID + "&Source=" + s,
			})
				.done(function (res) {
					if (res.Code === 200) {
						_this.checkout(res.Response.Cart, s);
					} else if (res.Code === 401) {
						AlertDialog.alert("請先登入", function () {
							location.reload();
						});
					} else {
						_this.isRunning = false;
						AlertDialog.alert("系統忙碌中");
					}
				})
				.fail(function () {
					console.log("error");
				});
		},
		checkout: function (data, source) {
			const _this = this;
			let idx = 0;
			var total = data.length;
			const datas = data;

			if (total === 0) {
				AlertDialog.alert("直播商品僅限於特定時間，商品目前已下架", function () {
					window.location.href = "/";
				});
				return;
			}

			callCart();

			function callCart() {
				$.ajax({
					url: API_URL.SHOPPING_CART,
					type: "POST",
					dataType: "JSON",
					data:
						"CustomMarketID=" +
						datas[idx].CustomMarketID +
						"&Count=" +
						datas[idx].Amount +
						"&LiveShowID=" +
						datas[idx].LiveShowID +
						"&Channel=" +
						source,
				})
					.done(function () {
						if (idx < total - 1) {
							idx++;
							callCart();
						} else {
							window.location.href = "/checkout";
						}
					})
					.fail(function () {
						console.log("error");
					});
			}
		},
	},
};
</script>

<style></style>
